import type { PositionalArgs } from 'ember-modifier';
import type AuthorizationService from 'volta/services/authorization';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { service } from '@ember/service';

export interface CanSignature {
  Args: {
    Positional: [string, string];
  };
  Return: boolean;
}

export default class Can extends Helper<CanSignature> {
  @service authorization!: AuthorizationService;

  // eslint-disable-next-line ember/no-observers
  onPermissionsInit = observer('authorization.permissions', () => {
    this.recompute();
  });

  compute([right, entityType]: PositionalArgs<CanSignature>) {
    return this.authorization.can(entityType, right);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    can: typeof Can;
  }
}
